import type { OrderDetailsData } from '../Context/NavigationContext';

/** The order fields Order Details opens with; employee and backoffice orders both carry them. */
export interface OrderDetailsSource {
  bp_sales_products_information: OrderDetailsData['order'];
  bp_order_id: string;
  bp_order_master_payment_information: OrderDetailsData['Payment_Information'];
  bp_order_master_receipt_reference_id?: string | null;
  bp_order_customer_information: string;
  bp_order_customer_id?: string | null;
  bp_order_customer_phone_number?: string | null;
  bp_order_assigned_staff_information?: OrderDetailsData['AssignedStaffInformation'];
  bp_order_master_order_status: string;
  bp_order_master_updated_at: string;
}

/** The data the Order Details screen shows for an order. */
export const toOrderDetailsData = (
  order: OrderDetailsSource,
): OrderDetailsData => ({
  order: order.bp_sales_products_information,
  orderID: order.bp_order_id,
  Payment_Information: order.bp_order_master_payment_information,
  ReceiptID: order.bp_order_master_receipt_reference_id ?? '',
  CustomerName: order.bp_order_customer_information,
  CustomerId: order.bp_order_customer_id ?? null,
  CustomerPhone: order.bp_order_customer_phone_number ?? null,
  AssignedStaffInformation: order.bp_order_assigned_staff_information ?? null,
  ordertype: order.bp_order_master_order_status,
  updatedAt: order.bp_order_master_updated_at,
});
